import React from 'react';
import { translate } from '../../../Services/translation';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import { getColor } from '../../../styling/mixins/colors';

const StyledProductCard = styled.div`
  display: flex;
  ${text('medium')}
  gap: 1.6rem;
  border-bottom: 2px solid ${getColor('grey', 100)};
  padding: 1.6rem;

  ${breakpoint('large')} {
    padding: 2.4rem;
  }

  .image {
    width: 64px;
    height: 64px;
    object-fit: cover;
  }

  .desc {
    display: flex;
    flex-direction: column;
    flex: 1;
    ${text('large')}
  }

  .title {
    ${text('large')}
    ${fontFamilyBold}
  }

  span:not(:last-child) {
    margin-bottom: 0.4rem;
  }

  .total {
    ${text('medium')}
    ${fontFamilyBold}
  }

  .info {
    ${text('medium')}
    color: ${getColor('grey', 600)};
  }
`;

const ProductCard = ({ product }) => {
  return (
    <StyledProductCard>
      <a href={product.link.href}>
        <img src={product.imageUrl} className="image" />
      </a>
      <div className="desc">
        <a href={product.link.href}>
          <span className="title">{product.name}</span>
        </a>
        <span className="info">
          {translate('product.articleno')}: {product.articleNumber}
        </span>
        {product.extraInfo &&
          product.extraInfo.items.map((item) => (
            <span className="info" key={'order-detail' + item.key}>
              {item.key}: {item.value}
            </span>
          ))}
        <span className="info">
          {translate('product.quantity')}: {product.quantityString}
        </span>
        <span className="total">
          {translate('product.total')}: {product.totalPrice}
        </span>
      </div>
    </StyledProductCard>
  );
};

export default ProductCard;
